if (!customElements.get('product-form-component')) {
  customElements.define(
    'product-form-component',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.init();
      }

      init() {
        this.form = this.querySelector('form');
        if (!this.form) return;
        this.variantIdInput.disabled = false;
	        this.captureExternalSubmitter = this.captureExternalSubmitter.bind(this);
	        this.proxySubmitLockAt = 0;
	        this.proxySubmitLockKey = '';
	        this.activeCartAttemptId = '';
	        this.activeCartSubmitKey = '';
	        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        document.addEventListener('pointerdown', this.captureExternalSubmitter, true);
        document.addEventListener('click', this.captureExternalSubmitter, true);
        this.cart = document.querySelector('cart-drawer');
        this.submitButton = this.form ? this.form.querySelector('.add-to-cart-button') : null;
        this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;
        this.checkbox = this.form ? this.form.querySelector('[id^="agree_condition-"]') : null;
        this.buyItNowButton = this.form ? this.form.querySelector('.shopify-payment-button, [data-buy-now-button]') : null;

        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.initAgreeCondition();
        this.syncInitialSubmitState();

        // Sync error messages to sticky add-to-cart error area (same section)
        this.setupErrorSync();
      }

      syncInitialSubmitState() {
        if (!this.submitButton) return;

        const productInfo = this.closest('product-info');
        const selectedVariantScript = productInfo ? productInfo.querySelector('variant-selects [data-selected-variant]') : null;
        if (!selectedVariantScript || !selectedVariantScript.textContent) return;

        let selectedVariant;
        try {
          selectedVariant = JSON.parse(selectedVariantScript.textContent);
        } catch (e) {
          return;
        }

        if (!selectedVariant) return;

        const sellingPlanInput = this.form ? this.form.querySelector('[name="selling_plan"]') : null;
        const needsSellingPlan = selectedVariant.requires_selling_plan && !(sellingPlanInput && sellingPlanInput.value);

        if (selectedVariant.available && !needsSellingPlan) {
          this.toggleSubmitButton(false);
          const quantityInput = this.form ? this.form.querySelector('.quantity__input') : null;
          const inventoryQuantity = Number(quantityInput ? quantityInput.getAttribute('data-inventory-quantity') : null);
          const inventoryPolicy = quantityInput ? quantityInput.getAttribute('data-inventory-policy') : null;
          if (inventoryQuantity <= 0 && inventoryPolicy === 'continue' && this.submitButtonText) {
            this.submitButtonText.textContent = (window.variantStrings && window.variantStrings.preOrder) || this.submitButtonText.textContent;
          }
        } else if (!selectedVariant.available) {
          this.toggleSubmitButton(true, window.variantStrings && window.variantStrings.soldOut);
        }
      }

      setupErrorSync() {
        try {
          const productInfo = this.closest('product-info');
          const sectionId = productInfo ? (productInfo.dataset.section || productInfo.dataset.originalSection) : null;
          if (!sectionId) return;

          const stickyATC = document.querySelector(`sticky-atc[data-sticky-section-id="${sectionId}"]`);
          if (!stickyATC) return;

          const mainErrorWrapper = this.querySelector('.product-form__error-message-wrapper');
          const stickyErrorWrapper = stickyATC.querySelector('.product-form__error-message-wrapper');
          if (!mainErrorWrapper || !stickyErrorWrapper) return;

          const syncFromMain = () => {
            const isVisible = !mainErrorWrapper.hasAttribute('hidden');
            const errorNode = mainErrorWrapper.querySelector('.product-form__error-message');
            const errorMessage = errorNode ? errorNode.textContent : '';
            stickyErrorWrapper.toggleAttribute('hidden', !isVisible || !errorMessage);
            if (isVisible && errorMessage) {
              const stickyErrorMessage = stickyErrorWrapper.querySelector('.product-form__error-message');
              if (stickyErrorMessage) stickyErrorMessage.textContent = errorMessage;
            }
          };

          // Initial sync
          syncFromMain();

          // Observe changes on main error wrapper
          this._errorObserver = new MutationObserver(syncFromMain);
          this._errorObserver.observe(mainErrorWrapper, {
            attributes: true,
            attributeFilter: ['hidden'],
            childList: true,
            subtree: true,
          });

          // Also listen to cartError pub/sub to copy message
          this.cartErrorUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, () => {
            syncFromMain();
          });
        } catch (e) {
          // silent
        }
      }

      initAgreeCondition() {
        if (!this.checkbox || !this.buyItNowButton) return;

        this.buyItNowButton.classList.add('disabled');
        if (this.buyItNowButton.matches('[data-buy-now-button]')) {
          this.buyItNowButton.setAttribute('aria-disabled', true);
          this.buyItNowButton.setAttribute('disabled', 'disabled');
        }

        this.checkbox.addEventListener('change', () => {
          this.buyItNowButton.classList.toggle('disabled', !this.checkbox.checked);
          if (this.buyItNowButton.matches('[data-buy-now-button]')) {
            this.buyItNowButton.toggleAttribute('aria-disabled', !this.checkbox.checked);
            this.buyItNowButton.toggleAttribute('disabled', !this.checkbox.checked);
          }
        });

        this.form.addEventListener('submit', (e) => {
          if (!this.checkbox.checked) {
            e.preventDefault();
          }
        });
      }

	      onSubmitHandler(evt) {
	        evt.preventDefault();
	        this.clearImmediateFeedbackTimer();
	        const submitter = evt.submitter instanceof HTMLElement
          ? evt.submitter
          : this.getRecentExternalSubmitter()
            ? this.getRecentExternalSubmitter()
          : document.activeElement instanceof HTMLElement
            ? document.activeElement
            : null;
        const isBuyNowSubmit = submitter ? submitter.matches('[data-buy-now-button]') : false;
        if (isBuyNowSubmit && this.checkbox && !this.checkbox.checked) {
          this.dispatchCartTrackingEvent('evolova:cart-add-error', {
            reason: 'buy_now_terms_unchecked',
            sourceArea: 'buy_now',
            target: submitter,
            isBuyNow: true,
          });
          this.finishBlockedSubmit(submitter, isBuyNowSubmit);
          return;
        }

	        const activeSubmitButton = isBuyNowSubmit ? submitter : (submitter || this.submitButton);
	        const activeSpinner = activeSubmitButton ? activeSubmitButton.querySelector('.loading__spinner') : null;
	        const shouldRedirectToCart = !isBuyNowSubmit && activeSubmitButton && activeSubmitButton.dataset && activeSubmitButton.dataset.cartRedirect === 'true';
	
	        const isImmediateFeedbackSubmitter = activeSubmitButton && activeSubmitButton.dataset && activeSubmitButton.dataset.evoImmediateAtcFeedback === 'true';
	        if (this.isCartSubmitLocked()) {
	          this.dispatchRepeatedCartSubmit(activeSubmitButton, isBuyNowSubmit);
	          if (activeSubmitButton) {
	            activeSubmitButton.setAttribute('aria-disabled', true);
	            activeSubmitButton.setAttribute('aria-busy', 'true');
	            this.setSubmitButtonBusyState(activeSubmitButton, true);
	          }
	          return;
	        }

	        if (!activeSubmitButton || (activeSubmitButton.getAttribute('aria-disabled') === 'true' && !isImmediateFeedbackSubmitter)) {
	          this.dispatchCartTrackingEvent('evolova:cart-add-error', {
	            reason: activeSubmitButton ? 'aria_disabled_button' : 'missing_submit_button',
            sourceArea: this.getTrackingSourceArea(activeSubmitButton, isBuyNowSubmit),
            target: activeSubmitButton,
            isBuyNow: isBuyNowSubmit,
          });
          this.finishBlockedSubmit(activeSubmitButton, isBuyNowSubmit);
          return;
        }

        this.error = false;

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (shouldRedirectToCart) this.prepareRedirectCartFormData(formData, activeSubmitButton);

        if (this.cart && !isBuyNowSubmit && !shouldRedirectToCart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        const properties = document.querySelectorAll('.product-form__input [name^="properties"]')

        properties.forEach(property => {
          if (property.type === 'file') {
            if (!property.files || property.files.length === 0 || !property.files[0]) return;
            formData.append(property.name, property.files[0]);
            return;
          }

          if (property.value == null || property.value === '') return;
          formData.append(property.name, property.value);
        })

	        config.body = formData;
	        let redirectingToCheckout = false;
            let cartConfirmed = false;
	        const trackingTarget = this.pendingProxySubmitter || activeSubmitButton;
	        const actionId = this.createCartActionId(formData.get('id'));
	        const cartTrackingBase = {
	          form: this.form,
	          target: trackingTarget,
	          variantId: formData.get('id'),
	          quantity: formData.get('quantity') || 1,
	          sourceArea: this.getTrackingSourceArea(trackingTarget, isBuyNowSubmit),
	          isBuyNow: isBuyNowSubmit,
	          actionId,
	          attemptId: actionId,
	        };
	        this.pendingProxySubmitter = null;
	        this.setCartSubmitLock(cartTrackingBase);
	        this.isSubmitting = true;

        this.debugCartStep('submit', {
          sourceArea: cartTrackingBase.sourceArea,
          variantId: cartTrackingBase.variantId,
          quantity: cartTrackingBase.quantity,
          redirect: shouldRedirectToCart,
          submitterId: activeSubmitButton.id || '',
          formId: this.getFormId(),
        });

        this.dispatchCartTrackingEvent('evolova:cart-add-click', cartTrackingBase);

        this.handleErrorMessage();

        if (!/^\d+$/.test(String(formData.get('id') || ''))) {
          this.handleErrorMessage(this.dataset.variantErrorMessage || 'Select an available option before adding to cart.');
          this.dispatchCartTrackingEvent('evolova:cart-add-error', {
            ...cartTrackingBase,
            reason: 'missing_variant_id',
          });
          this.isSubmitting = false;
          this.clearCartSubmitLock(actionId);
          this.finishBlockedSubmit(activeSubmitButton, isBuyNowSubmit);
          return;
        }

        activeSubmitButton.setAttribute('aria-disabled', true);
        activeSubmitButton.setAttribute('aria-busy', 'true');
        if (activeSpinner) activeSubmitButton.classList.add('loading');
        this.setSubmitButtonBusyState(activeSubmitButton, true);
        if (activeSpinner) activeSpinner.classList.remove('hidden');

        // Also reflect loading state on the sticky add-to-cart button (if present)
        const productInfo = this.closest('product-info');
        const sectionId = productInfo ? (productInfo.dataset.section || productInfo.dataset.originalSection) : null;
        const stickyAddButtons = this.getStickySubmitButtons(sectionId);
        if (!isBuyNowSubmit) this.setSubmitButtonsBusyState(stickyAddButtons, true);

        const cartAddUrl = this.getCartAddUrl(shouldRedirectToCart);
        this.debugCartStep('primary_add_start', {
          url: cartAddUrl,
          fields: this.debugFormDataFields(formData),
        });

        this.fetchCartAdd(cartAddUrl, config, { shouldRedirectToCart })
          .then((response) => {
            cartConfirmed = !response.status;
            if (response.status) {
              this.debugCartStep('primary_add_status_error', {
                status: response.status,
                message: response.message || response.description || '',
              });
              const errorReason = response.message || response.description || 'shopify_cart_add_error';
              const shouldLockButton = this.isInventoryLockError(response);
              this.dispatchCartTrackingEvent('evolova:cart-add-error', {
                ...cartTrackingBase,
                response,
                reason: errorReason,
                message: response.description || response.message,
              });
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form-component',
                sourceArea: cartTrackingBase.sourceArea,
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description || response.message || this.dataset.cartErrorMessage);

              const soldOutMessage = activeSubmitButton.querySelector('.sold-out-message');
              if (shouldLockButton && soldOutMessage) {
                activeSubmitButton.setAttribute('aria-disabled', true);
                if (this.submitButtonText) this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
              }
              return;
            } else if (isBuyNowSubmit) {
              this.debugCartStep('buy_now_redirect', { url: `${(window.routes && window.routes.root_url) || '/'}checkout` });
              this.dispatchCartTrackingEvent('evolova:cart-add-success', {
                ...cartTrackingBase,
                response,
                source: 'buy_now_cart_add',
              });
              this.dispatchCartTrackingEvent('evolova:checkout-handoff', {
                ...cartTrackingBase,
                response,
                source: 'buy_now',
              });
              redirectingToCheckout = true;
              this.redirectAfterTracking(`${(window.routes && window.routes.root_url) || '/'}checkout`);
              return;
            } else if (shouldRedirectToCart) {
              this.debugCartStep('redirect_fast_path_success', { url: `${(window.routes && window.routes.cart_url) || '/cart'}` });
              this.dispatchCartTrackingEvent('evolova:cart-add-success', {
                ...cartTrackingBase,
                response,
                source: 'sticky_cart_redirect',
              });
              redirectingToCheckout = true;
              this.redirectAfterTracking(`${(window.routes && window.routes.cart_url) || '/cart'}`);
              return;
            } else if (!this.cart) {
              this.debugCartStep('cart_add_redirect_no_drawer', { url: `${window.routes && window.routes.cart_url}` });
              this.dispatchCartTrackingEvent('evolova:cart-add-success', {
                ...cartTrackingBase,
                response,
                source: 'cart_add_redirect',
              });
              this.redirectAfterTracking(`${window.routes && window.routes.cart_url}`);
              return;
            }

            this.dispatchCartTrackingEvent('evolova:cart-add-success', {
              ...cartTrackingBase,
              response,
              source: 'cart_add_drawer',
            });

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form-component',
	                sourceArea: cartTrackingBase.sourceArea,
                  actionId: cartTrackingBase.actionId,
	                productVariantId: formData.get('id'),
	                cartData: response,
	              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => {
                  if (this.cart && typeof this.cart.renderContents === 'function') {
                    this.cart.renderContents(response);
                  }
                });
              },{ once: true });
              quickAddModal.hide(true);
            } else {
              if (this.cart && typeof this.cart.renderContents === 'function') {
                this.cart.renderContents(response);
              }
            }
          })
          .catch(async (e) => {
            console.error(e);
            if (cartConfirmed) {
              // Rendering a drawer is separate from Shopify confirming the add.
              redirectingToCheckout = true;
              this.redirectAfterTracking((window.routes && window.routes.cart_url) || '/cart');
              return;
            }
            this.debugCartStep('primary_add_exception', {
              message: (e && e.message) || String(e),
              redirect: shouldRedirectToCart,
            });
            this.handleErrorMessage(this.dataset.cartErrorMessage || 'We could not confirm the cart update. Check your cart before trying again.');
            this.dispatchCartTrackingEvent('evolova:cart-add-error', {
              ...cartTrackingBase,
              reason: (e && e.reason) || 'network_error',
              message: (e && e.message) || String(e),
            });
          })
	          .finally(() => {
	            if (redirectingToCheckout) return;
	            this.isSubmitting = false;
	            this.clearCartSubmitLock(cartTrackingBase.actionId);
	
	            activeSubmitButton.classList.remove('loading');
            activeSubmitButton.removeAttribute('aria-busy');
            if (!this.error) this.setSubmitButtonBusyState(activeSubmitButton, false);
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) activeSubmitButton.removeAttribute('aria-disabled');
            if (activeSpinner) activeSpinner.classList.add('hidden');

            // Clear loading state on the sticky add-to-cart button (if present)
            const productInfo = this.closest('product-info');
            const sectionId = productInfo ? (productInfo.dataset.section || productInfo.dataset.originalSection) : null;
            const stickyAddButtons = this.getStickySubmitButtons(sectionId);
            if (!isBuyNowSubmit) this.setSubmitButtonsBusyState(stickyAddButtons, false, this.error);
          });
      }

      disconnectedCallback() {
        try {
          document.removeEventListener('pointerdown', this.captureExternalSubmitter, true);
          document.removeEventListener('click', this.captureExternalSubmitter, true);
          this.clearImmediateFeedbackTimer();
          if (this.cartErrorUnsubscriber) this.cartErrorUnsubscriber();
          if (this._errorObserver) this._errorObserver.disconnect();
        } catch (e) {
          // silent
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) this.errorMessage.textContent = errorMessage;
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      captureExternalSubmitter(event) {
        const target = event.target instanceof HTMLElement
          ? event.target.closest('button[type="submit"], input[type="submit"], button[name="add"], input[name="add"]')
          : null;
        if (!target) return;

        const targetForm = target.getAttribute('form');
        const formId = this.getFormId();
        if (this.form.contains(target) || (targetForm && formId && targetForm === formId)) {
          this.lastSubmitter = target;
          this.lastSubmitterAt = Date.now();
          this.applyImmediateStickyFeedback(target);
          if ((event.type === 'pointerdown' || event.type === 'click') && this.handleSubmitProxyClick(event, target)) return;
        }
      }

      handleSubmitProxyClick(event, target) {
        const targetButtonId = this.getSubmitProxyTargetId(target);
        if (!targetButtonId) return false;

        const proxyKey = `${targetButtonId}:${target && target.id ? target.id : targetButtonId}`;
        if (this.isRecentProxySubmit(proxyKey)) {
          event.preventDefault();
          event.stopPropagation();
          return true;
        }

        const proxiedButton = document.getElementById(targetButtonId);
        if (!proxiedButton || proxiedButton === target || proxiedButton.disabled || proxiedButton.getAttribute('aria-disabled') === 'true') {
          return false;
        }

        event.preventDefault();
        event.stopPropagation();
        this.pendingProxySubmitter = target;
        this.pendingProxyQuantity = this.getRedirectQuantity(target);
        this.lastSubmitter = proxiedButton;
        this.lastSubmitterAt = Date.now();
        this.proxySubmitLockAt = Date.now();
        this.proxySubmitLockKey = proxyKey;
        this.submitProxiedButton(proxiedButton);
        return true;
      }

      isRecentProxySubmit(proxyKey) {
        return (
          this.proxySubmitLockKey === proxyKey &&
          this.proxySubmitLockAt &&
          Date.now() - this.proxySubmitLockAt < 1200
        );
      }

      submitProxiedButton(proxiedButton) {
        try {
          if (this.form && typeof this.form.reportValidity === 'function' && !this.form.reportValidity()) return;
          if (this.checkbox && !this.checkbox.checked) return;

          this.onSubmitHandler({
            preventDefault: () => {},
            submitter: proxiedButton,
            __evoStickyProxySubmit: true,
          });
          return;
        } catch (directSubmitError) {
          this.debugCartStep('proxy_direct_submit_exception', {
            message: (directSubmitError && directSubmitError.message) || String(directSubmitError),
          });
        }

        if (this.form && typeof this.form.requestSubmit === 'function') {
          try {
            this.form.requestSubmit(proxiedButton);
            return;
          } catch (e) {
            // Fall through to click-based submit for older WebKit variants.
          }
        }

        proxiedButton.click();
      }

      getSubmitProxyTargetId(target) {
        const explicitTargetId = target && target.dataset ? target.dataset.evoSubmitProxyFor : '';
        if (explicitTargetId) return explicitTargetId;

        const formId = this.getFormId();
        const stickyScope = target ? target.closest('sticky-atc') : null;
        const isStickyAddTarget =
          stickyScope &&
          ((target && target.name === 'add') ||
            (target && typeof target.id === 'string' && target.id.indexOf('StickyCart-ProductSubmitButton') === 0));
        const targetForm = target ? target.getAttribute('form') : '';

        if (!isStickyAddTarget || !formId || targetForm !== formId) return '';

        const sectionId = stickyScope.getAttribute('data-sticky-section-id');
        if (sectionId) {
          const sectionButtonId = `ProductSubmitButton-${sectionId}`;
          if (document.getElementById(sectionButtonId)) return sectionButtonId;
        }

        const mainButton = this.submitButton || this.form.querySelector('button[name="add"][type="submit"], input[name="add"][type="submit"]');
        return mainButton && mainButton.id ? mainButton.id : '';
      }

      getRecentExternalSubmitter() {
        if (!this.lastSubmitter || !this.lastSubmitterAt) return null;
        if (Date.now() - this.lastSubmitterAt > 2000) return null;
        return this.lastSubmitter;
      }

      getStickySubmitButtons(sectionId) {
        const formId = this.getFormId();
        if (!sectionId && !formId) return [];

        const buttons = [];
        const addButton = sectionId ? document.getElementById(`StickyCart-ProductSubmitButton-${sectionId}`) : null;
        const directAddButton = sectionId ? document.getElementById(`StickyCart-ProductSubmitButton-ToggleVariants-${sectionId}`) : null;
        if (addButton) buttons.push(addButton);
        if (directAddButton) buttons.push(directAddButton);

        const stickyScope = sectionId
          ? document.querySelector(`sticky-atc[data-sticky-section-id="${sectionId}"]`)
          : document.querySelector(`sticky-atc[form="${formId}"]`);
        if (stickyScope) {
          stickyScope
            .querySelectorAll(`button[type="submit"][form="${formId}"], button[type="button"][form="${formId}"], button[name="add"][form="${formId}"]`)
            .forEach((button) => {
              if (!buttons.includes(button)) buttons.push(button);
            });
        }

        if (formId) {
          document
            .querySelectorAll(`.evo-pdp-mobile-action__button[type="submit"][form="${formId}"], .evo-pdp-mobile-action__button[name="add"][form="${formId}"]`)
            .forEach((button) => {
              if (!buttons.includes(button)) buttons.push(button);
            });
        }

        return buttons;
      }

      getFormId() {
        return this.form ? this.form.getAttribute('id') || '' : '';
      }

      getCartAddUrl(forceJson = false) {
        const rootUrl = (window.routes && window.routes.root_url) || '/';
        const cartAddUrl = (window.routes && window.routes.cart_add_url) || `${rootUrl}cart/add`;
        if (cartAddUrl.endsWith('.js')) return cartAddUrl;
        return `${cartAddUrl.replace(/\/$/, '')}.js`;
      }

      async fetchCartAdd(cartAddUrl, config, options = {}) {
        // A lost response does not mean the non-idempotent add failed on Shopify.
        // Never replay it automatically or infer success from an existing cart line.
        const response = await fetch(cartAddUrl, config);
        this.debugCartStep('primary_add_response', { status: response.status, ok: response.ok });
        return this.parseCartAddResponse(response);
      }

      async parseCartAddResponse(response, shouldRedirectToCart = false) {
        try {
          const cartResponse = await response.json();
          if (!cartResponse || typeof cartResponse !== 'object' || Array.isArray(cartResponse)) throw new Error('Invalid cart response.');
          if (!response.ok && !cartResponse.status) cartResponse.status = response.status;
          if (!cartResponse.status) {
            const lines = Array.isArray(cartResponse.items) ? cartResponse.items : [cartResponse];
            if (!lines.length || !lines.every((line) => line && (line.variant_id || line.id) && Number(line.quantity) > 0)) {
              throw new Error('Cart response did not confirm an added item.');
            }
          }
          return cartResponse;
        } catch (error) {
          error.reason = 'cart_response_unconfirmed';
          throw error;
        }
      }


      prepareRedirectCartFormData(formData, button) {
        const variantInput = this.variantIdInput;
        const variantId = variantInput && !variantInput.disabled ? variantInput.value : '';
        if (variantId) formData.set('id', variantId);
        else formData.delete('id');

        const quantity = this.pendingProxyQuantity || this.getRedirectQuantity(button);
        this.pendingProxyQuantity = null;
        if (quantity) formData.set('quantity', quantity);

        formData.delete('sections');
        formData.delete('sections_url');
      }

      getRedirectQuantity(button) {
        const stickyScope = button ? button.closest('sticky-atc') : null;
        const quantityInput =
          (stickyScope ? stickyScope.querySelector('[name="quantity"]') : null) ||
          (this.form ? this.form.querySelector('[name="quantity"]') : null);
        const quantity = Number((quantityInput && quantityInput.value) || 1);
        return Number.isFinite(quantity) && quantity > 0 ? String(quantity) : '1';
      }


      setSubmitButtonsBusyState(buttons, isBusy, keepLocked = false) {
        buttons.forEach((button) => {
          const spinner = button.querySelector('.loading__spinner');
          button.classList.toggle('loading', isBusy && !!spinner);
          button.toggleAttribute('aria-busy', isBusy);
          if (isBusy) {
            button.dataset.evoImmediateAtcFeedback = 'true';
          } else {
            delete button.dataset.evoImmediateAtcFeedback;
          }
          if (!isBusy && !keepLocked) button.removeAttribute('aria-disabled');

          if (spinner) spinner.classList.toggle('hidden', !isBusy);

          if (isBusy || !keepLocked) this.setSubmitButtonBusyState(button, isBusy);
        });
      }

      applyImmediateStickyFeedback(target) {
        const stickyScope = target.closest('sticky-atc');
        const formId = this.getFormId();
        const isMobileActionButton =
          target.matches('.evo-pdp-mobile-action__button') &&
          target.getAttribute('form') === formId;
        if ((!stickyScope && !isMobileActionButton) || target.disabled || target.getAttribute('aria-disabled') === 'true') return;

        const sectionId = stickyScope ? stickyScope.getAttribute('data-sticky-section-id') : null;
        const buttons = this.getStickySubmitButtons(sectionId);
        if (!buttons.includes(target)) buttons.push(target);
        this.setSubmitButtonsBusyState(buttons, true);

        this.clearImmediateFeedbackTimer();
        this.immediateFeedbackTimer = window.setTimeout(() => {
          if (this.isSubmitting) return;
          this.setSubmitButtonsBusyState(buttons, false);
        }, 2500);
      }

      clearImmediateFeedbackTimer() {
        if (!this.immediateFeedbackTimer) return;
        window.clearTimeout(this.immediateFeedbackTimer);
        this.immediateFeedbackTimer = null;
      }

	      finishBlockedSubmit(button, isBuyNow = false) {
	        this.isSubmitting = false;
	        this.clearCartSubmitLock();
	        this.clearImmediateFeedbackTimer();

        if (button) {
          button.classList.remove('loading');
          button.removeAttribute('aria-busy');
          this.setSubmitButtonBusyState(button, false);
        }

        if (isBuyNow) return;
        const productInfo = this.closest('product-info');
        const sectionId = productInfo ? (productInfo.dataset.section || productInfo.dataset.originalSection) : null;
	        this.setSubmitButtonsBusyState(this.getStickySubmitButtons(sectionId), false);
	      }

	      isCartSubmitLocked() {
	        return (
	          this.isSubmitting ||
	          (this.form && this.form.dataset && this.form.dataset.evoSubmitting === 'true')
	        );
	      }

	      setCartSubmitLock(detail = {}) {
	        this.activeCartAttemptId = detail.actionId || detail.attemptId || '';
	        this.activeCartSubmitKey = [
	          detail.variantId || 'unknown',
	          detail.quantity || 1,
	          detail.sourceArea || 'product_form',
	        ].join(':');
	        if (this.form && this.form.dataset) {
	          this.form.dataset.evoSubmitting = 'true';
	          if (this.activeCartAttemptId) this.form.dataset.evoCartAttemptId = this.activeCartAttemptId;
	          if (this.activeCartSubmitKey) this.form.dataset.evoCartSubmitKey = this.activeCartSubmitKey;
	        }
	      }

	      clearCartSubmitLock(actionId = '') {
	        if (actionId && this.activeCartAttemptId && actionId !== this.activeCartAttemptId) return;
	        this.activeCartAttemptId = '';
	        this.activeCartSubmitKey = '';
	        if (!this.form || !this.form.dataset) return;
	        delete this.form.dataset.evoSubmitting;
	        delete this.form.dataset.evoCartAttemptId;
	        delete this.form.dataset.evoCartSubmitKey;
	      }

	      dispatchRepeatedCartSubmit(button, isBuyNow = false) {
	        const variantId = this.variantIdInput ? this.variantIdInput.value : '';
	        const quantityInput = this.form ? this.form.querySelector('[name="quantity"]') : null;
	        this.dispatchCartTrackingEvent('evolova:cart-add-error', {
	          reason: 'repeated_click_ignored',
	          message: 'Repeated add-to-cart click ignored while the first request is still in progress.',
	          target: button,
	          variantId,
	          quantity: (quantityInput && quantityInput.value) || 1,
	          sourceArea: this.getTrackingSourceArea(button, isBuyNow),
	          isBuyNow,
	          actionId: this.activeCartAttemptId || (this.form && this.form.dataset && this.form.dataset.evoCartAttemptId) || '',
	          attemptId: this.activeCartAttemptId || (this.form && this.form.dataset && this.form.dataset.evoCartAttemptId) || '',
	          repeatedClick: true,
	        });
	      }
	
	      setSubmitButtonBusyState(button, isBusy) {
        const textElement = this.getSubmitButtonTextElement(button);
        if (!textElement) return;

        if (isBusy) {
          if (!button.dataset.evoAtcOriginalText) {
            button.dataset.evoAtcOriginalText = textElement.textContent.trim();
          }
          textElement.textContent = (window.variantStrings && window.variantStrings.addingToCart) || 'Adding...';
          return;
        }

        if (!button.dataset.evoAtcOriginalText) return;
        textElement.textContent = button.dataset.evoAtcOriginalText;
        delete button.dataset.evoAtcOriginalText;
      }

      getSubmitButtonTextElement(button) {
        if (!button) return null;

        for (const child of button.children) {
          if (
            child.tagName === 'SPAN' &&
            !child.classList.contains('sold-out-message') &&
            !child.classList.contains('icon-wrap') &&
            !child.classList.contains('svg-wrapper') &&
            child.textContent.trim()
          ) {
            return child;
          }
        }

        const nestedText = button.querySelector('.add-to-cart-text, .add-to-cart-text--choose-options');
        if (nestedText) return nestedText;

        const hasDirectText = Array.from(button.childNodes).some(
          (node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim()
        );
        if (hasDirectText && button.matches('.evo-pdp-mobile-action__button')) return button;

        return null;
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      getTrackingSourceArea(target, isBuyNow = false) {
        if (isBuyNow) return 'buy_now';
        return (
          (target && target.dataset && target.dataset.sourceArea) ||
          (this.form && this.form.dataset && this.form.dataset.sourceArea) ||
          (this.dataset && this.dataset.sourceArea) ||
          'product_form'
        );
      }

      dispatchCartTrackingEvent(name, detail = {}) {
        try {
          document.dispatchEvent(
            new CustomEvent(name, {
              detail: {
                form: this.form,
                ...detail,
              },
            })
          );
        } catch (e) {
          // Tracking must never block the product form.
        }
      }

      redirectAfterTracking(url) {
        if (!url || this.redirectAfterTrackingScheduled) return;
        this.redirectAfterTrackingScheduled = true;
        this.debugCartStep('redirect_scheduled', { url });

        const redirect = () => {
          this.debugCartStep('redirect_execute', { url });
          if (typeof window.location.assign === 'function') {
            window.location.assign(url);
          } else {
            window.location.href = url;
          }
        };

        window.setTimeout(redirect, 0);
        window.setTimeout(() => {
          if (document.visibilityState !== 'hidden') redirect();
        }, 1200);
      }

      isCartDebugEnabled() {
        try {
          return (
            /(?:^|[?&])evo_atc_debug=1(?:&|$)/.test(window.location.search) ||
            window.sessionStorage.getItem('evoAtcDebug') === '1'
          );
        } catch (e) {
          return false;
        }
      }

      debugCartStep(step, detail = {}) {
        if (!this.isCartDebugEnabled()) return;
        try {
          const entry = {
            step,
            time: Date.now(),
            detail,
          };
          window.evoAtcDebugLog = window.evoAtcDebugLog || [];
          window.evoAtcDebugLog.push(entry);
          if (window.console && typeof window.console.info === 'function') {
            window.console.info('[Evolova ATC debug]', step, detail);
          }
        } catch (e) {
          // Debug logging must never affect cart behavior.
        }
      }

      debugFormDataFields(formData) {
        if (!this.isCartDebugEnabled() || !formData || typeof formData.forEach !== 'function') return [];
        const fields = [];
        try {
          formData.forEach((value, key) => {
            fields.push([key, String(value)]);
          });
        } catch (e) {
          return [];
        }
        return fields;
      }

      createCartActionId(variantId) {
        return [
          'atc',
          variantId || 'unknown',
          Date.now(),
          Math.random().toString(36).slice(2, 8),
        ].join(':');
      }

      isInventoryLockError(response = {}) {
        const message = [
          response.message,
          response.description,
          response.errors && typeof response.errors === 'string' ? response.errors : '',
        ]
          .filter(Boolean)
          .join(' ')
          .toLowerCase();

        return (
          response.status === 422 &&
          /sold out|unavailable|not available|out of stock|inventory/.test(message)
        );
      }
    }
  );
}
